import axiosInstance from './axiosInstance';

const registrationService = {
    // Public endpoint
    createRegistration: async (registrationData) => {
        const response = await axiosInstance.post('/registrations', registrationData);
        return response.data;
    },

    // Admin endpoints
    getRegistrations: async (filters = {}) => {
        const params = new URLSearchParams(filters).toString();
        const response = await axiosInstance.get(`/registrations?${params}`);
        return response.data;
    },

    updateRegistrationStatus: async (id, statusData) => {
        const response = await axiosInstance.patch(`/registrations/${id}`, statusData);
        return response.data;
    },

    deleteRegistration: async (id) => {
        const response = await axiosInstance.delete(`/registrations/${id}`);
        return response.data;
    }
};

export default registrationService;
